import { render, staticRenderFns } from "./Portion.vue?vue&type=template&id=2f8c7322&scoped=true&"
import script from "./Portion.vue?vue&type=script&lang=js&"
export * from "./Portion.vue?vue&type=script&lang=js&"
import style0 from "./Portion.vue?vue&type=style&index=0&id=2f8c7322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8c7322",
  null
  
)

export default component.exports